import React from 'react';
import logo from "../storage/images/logo.png";
import { Link } from 'react-router-dom';

export function Faq() {
    const [openIndex, setOpenIndex] = React.useState<number | null>(0);

    const toggleAccordion = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const faqItems = [
        {
            question: "Why did I get charged before my free trial ended?",
            answer: (
                <>
                    <p style={{
                        margin: 0,
                        textAlign: 'center'
                    }}>
                        According to Apple, when you sign up for a 3-day trial, you may get charged within the last 24 hours of your trial period.
                    </p>
                    <p style={{
                        margin: '1rem 0',
                        textAlign: 'center'
                    }}>
                        Here's the exact statement from <a href="https://support.apple.com/en-us/HT204084" style={{ color: '#13AA08', textDecoration: 'none' }}>Apple's website</a>: "If you signed up for a free or discounted trial subscription and you don't want to renew it, cancel it at least 24 hours before the trial ends."
                    </p>
                    <p style={{
                        margin: 0,
                        textAlign: 'center'
                    }}>
                        The payment processes on App Store are completely managed by Apple, so unfortunately, this is a process Freeup team is unable to control.
                    </p>
                </>
            )
        },
        {
            question: "How do I cancel my subscription?",
            answer: (
                <div style={{ textAlign: 'center' }}>
                    <p>1. Go to the Settings app on your iPhone</p>
                    <p>2. Choose iTunes & App Store</p>
                    <p>3. Tap your Apple ID at the top of the screen</p>
                    <p>4. Tap View Apple ID (you might need to sign in or use Touch ID)</p>
                    <p>5. Tap Subscriptions</p>
                    <p>6. Under Subscriptions, tap Freeup</p>
                </div>
            )
        },
        {
            question: "How do I request a refund?",
            answer: (
                <p style={{
                    margin: 0,
                    textAlign: 'center'
                }}>
                    Unfortunately, <strong>Freeup is unable to refund Apple payments</strong>. If you think you were charged without a permission and would like to request a refund, we recommend reaching out to Apple Support.
                </p>
            )
        }
    ];

    return (
        <div style={{ 
            padding: 50, 
            backgroundColor: '#f8f9fa', 
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            color: '#212529',
            fontFamily: 'Arial, sans-serif'
        }}>
            {/* Support Section */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginBottom: '4rem',
                maxWidth: '800px',
                width: '100%',
                textAlign: 'center'
            }}>
                <div style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '16px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '1.5rem'
                }}>
                    <Link to="/">
                        <img src={logo} style={{width: "80px", height: "80px", cursor: 'pointer'}}/>
                    </Link>
                </div>
                
                <h1 style={{
                    fontSize: '3rem',
                    marginBottom: '1.5rem',
                    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                    color: '#212529'
                }}>
                    Freeup Support
                </h1>
                
                <p style={{
                    fontSize: '1.2rem',
                    marginBottom: '1rem',
                    color: '#212529'
                }}>
                    Encountered a problem while using <a href="#" style={{ color: '#13AA08', textDecoration: 'none' }}>Freeup</a>? You may find the solution in the <a href="#faq" style={{ color: '#13AA08', textDecoration: 'none' }}>FAQ section below</a>.
                </p>
                
                <p style={{
                    fontSize: '1.2rem',
                    marginBottom: '2rem',
                    color: '#212529'
                }}>
                    If you couldn't find your answer in the FAQ section, send us an email at <a href="mailto:support@getfreeup.ai" style={{ color: '#13AA08', textDecoration: 'none' }}>support@getfreeup.ai</a>, and we'll be in touch shortly.
                </p>
                
                <div style={{
                    display: 'flex',
                    gap: '1rem',
                    justifyContent: 'center',
                    width: '100%'
                }}>
                    <a href="#faq" style={{
                        backgroundColor: '#13AA08',
                        color: 'white',
                        padding: '0.8rem 2rem',
                        borderRadius: '50px',
                        textDecoration: 'none',
                        fontWeight: 'bold',
                        fontSize: '1.2rem',
                        textAlign: 'center',
                        minWidth: '180px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        Read FAQs
                    </a>
                    <a href="mailto:support@getfreeup.ai" style={{
                        backgroundColor: '#13AA08',
                        color: 'white',
                        padding: '0.8rem 2rem',
                        borderRadius: '50px',
                        textDecoration: 'none',
                        fontWeight: 'bold',
                        fontSize: '1.2rem',
                        textAlign: 'center',
                        minWidth: '180px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        Contact Support
                    </a>
                </div>
            </div>

            <h1 id="faq" style={{
                fontSize: '3rem',
                marginBottom: '2rem',
                textAlign: 'center',
                color: '#212529'
            }}>
                Frequently Asked Questions
            </h1>

            <div style={{
                maxWidth: '800px',
                width: '100%'
            }}>
                {faqItems.map((item, index) => (
                    <div 
                        key={index}
                        style={{
                            backgroundColor: index === openIndex ? '#f5f5f7' : '#f5f5f7',
                            borderRadius: '10px',
                            marginBottom: '1rem',
                            overflow: 'hidden',
                            color: '#212529',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
                        }}
                    >
                        <div 
                            onClick={() => toggleAccordion(index)}
                            style={{
                                padding: '1.5rem',
                                cursor: 'pointer',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative'
                            }}
                        >
                            <h2 style={{
                                fontSize: '1.25rem',
                                margin: 0,
                                fontWeight: 'bold',
                                textAlign: 'center',
                                color: openIndex === index ? '#13AA08' : '#212529'
                            }}>
                                {item.question}
                            </h2>
                        </div>
                        
                        {openIndex === index && (
                            <div style={{
                                padding: '0 1.5rem 1.5rem',
                                transition: 'all 0.3s ease'
                            }}>
                                {item.answer}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
